import { useTranslation } from "react-i18next";
const STRAPI_URL = process.env.REACT_APP_STRAPI_URL || "http://localhost:1337";

const RecipeTitle = ({
  title,
  image,
  description,
  prepTime,
  cookTime,
  totalTime,
  recipeYield,
  difficulty,
  recipe_categories,
  recipe_cuisines,
  recipe_occasions,
  cooking_styles,
  cooking_techniques,
  dietary_preferences,
  recipe_courses,
}) => {
  const { t } = useTranslation();

  const renderDescription = () => {
    if (!Array.isArray(description)) return null;

    return description.map((block, index) => {
      if (block.type === "paragraph") {
        return (
          <p
            key={index}
            className="display-5 text-dark"
            style={{ lineHeight: "100%" }}
          >
            {block.children?.map((child, idx) => (
              <span key={idx}>{child.text}</span>
            ))}
          </p>
        );
      }
      return null;
    });
  };

  const renderTags = (labelKey, items, field = "title") => {
    if (!Array.isArray(items) || items.length === 0) return null;

    return (
      <li className="list-group-item d-flex justify-content-between align-items-start text-black">
        <span>
          <p className="lead" style={{ lineHeight: "90%", textTransform: "uppercase" }}>
            {t(labelKey)}
          </p>
        </span>
        <p className="lead" style={{ lineHeight: "90%", textTransform: "uppercase", textAlign: "right" }}>
          {items.map((item) => item[field] || item.name || "Untitled").join(", ")}
        </p>
      </li>
    );
  };

  return (
    <div className="container mt-10">
      <div className="row justify-content-center">
        <div className="col-12">
          <h1 className="mb-1 text-black" style={{ fontWeight: "bold" }}>
            {title}
          </h1>

          {renderDescription()}

  		  {image && (
			  <img
				  src={`${STRAPI_URL}${image.url}`}
				  alt={image.title || ""}
				  className="col-12 equal-2-1"
				  style={{ display: "block" }}
				/>
			)}



          <ol className="list-group list-group-separated col-12 mt-4">
            {renderTags("recipe.cuisines", recipe_cuisines)}
            {renderTags("recipe.occasions", recipe_occasions)}
            {renderTags("recipe.dietaryPreferences", dietary_preferences)}
            {renderTags("recipe.courses", recipe_courses)}

            {difficulty && (
			  <li className="list-group-item d-flex justify-content-between align-items-start text-black">
				<span>
				  <p className="lead" style={{ lineHeight: "90%", textTransform: "uppercase" }}>
					{t("recipe.difficulty", "Difficulty")}
				  </p>
				</span>
				<p className="lead" style={{ lineHeight: "90%", textTransform: "uppercase" }}>
				  {t(`recipe.difficultyLevels.${difficulty.toLowerCase()}`)}
				</p>
			  </li>
			)}

            {recipeYield && (
              <li className="list-group-item d-flex justify-content-between align-items-start text-black">
                <span>
                  <p className="lead" style={{ lineHeight: "90%", textTransform: "uppercase" }}>
                    {t("recipe.yield", "Yelds")}
                  </p>
                </span>
                <p className="lead" style={{ lineHeight: "90%", textTransform: "uppercase" }}>
                  {recipeYield}
                </p>
              </li>
            )}

            {prepTime > 0 && (
              <li className="list-group-item d-flex justify-content-between align-items-start text-black">
                <span>
                  <p className="lead" style={{ lineHeight: "90%", textTransform: "uppercase" }}>
                    {t("recipe.prepTime", "Preparation Time")}
                  </p>
                </span>
                <p className="lead" style={{ lineHeight: "90%", textTransform: "uppercase" }}>
                  {prepTime} min
                </p>
              </li>
            )}

            {cookTime > 0 && (
              <li className="list-group-item d-flex justify-content-between align-items-start text-black">
                <span>
                  <p className="lead" style={{ lineHeight: "90%", textTransform: "uppercase" }}>
                    {t("recipe.cookTime", "Cook time")}
                  </p>
                </span>
                <p className="lead" style={{ lineHeight: "90%", textTransform: "uppercase" }}>
                  {cookTime} min
                </p>
              </li>
            )}

            {totalTime > 0 && (
              <li className="list-group-item d-flex justify-content-between align-items-start text-black">
                <span>
                  <p className="lead" style={{ lineHeight: "90%", textTransform: "uppercase" }}>
                    {t("recipe.totalTime", "Total time")}
                  </p>
                </span>
                <p className="lead" style={{ lineHeight: "90%", textTransform: "uppercase" }}>
                  {totalTime} min
                </p>
              </li>
            )}
          </ol>
        </div>
      </div>
    </div>
  );
};

export default RecipeTitle;
